class RiseModal extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    this.trapFocus()
  }

  setupListeners () {
    super.setupListeners()

    this.externalEls.trigger?.elements.forEach(trigger => {
      trigger.addEventListener('click', e => this.showModal(e))
    })

    this.els.close.element.addEventListener('click', this.hideModal.bind(this))

    this.addEventListener('keydown', e => this.handleKeyDown(e.key))
  }

  showModal (e) {
    if (!e.target.classList.contains('btn-Button-inactive')) {
      this.setAttribute('aria-hidden', false)
      this.setAttribute('aria-expanded', true)
      document.body.classList.add('util-SiteOverflowed')

      this.els.close.element.focus()
    }
  }

  handleKeyDown (key) {
    if (key === 'Escape' /* ESC */) {
      this.hideModal()
    }
  }

  hideModal () {
    this.setAttribute('aria-hidden', true)
    this.setAttribute('aria-expanded', false)
    document.body.classList.remove('util-SiteOverflowed')

    this.removeEventListener('keydown', e => this.handleKeyDown(e.key))
  }

  trapFocus () {
    const focusableEls = this.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
    )
    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9

    this.addEventListener('keydown', e => {
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    })
  }
}

if (!customElements.get('rise-modal')) {
  customElements.define('rise-modal', RiseModal)
}
